import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoTn: CultureInfo = {
  name: 'tn',
  displayName: 'Tswana',
  iso3LanguageCode: 'tsn',
  iso2LanguageCode: 'tn',
  ietfLanguageTag: 'tn',
  parent: null
};
